import { Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { KSelect } from '@/ui-library/components/molecules/KSelect/KSelect';
import { WeeklySelectorProps } from '../types';

export const WeeklySelector = ({
  dayOfWeekOptions,
  selectedDayOfWeek,
  setSelectedDayOfWeek,
}: WeeklySelectorProps) => (
  <Flex gap="6px" flexDirection="column" mb="12px">
    <KText size="sm-medium" color="secondary-900">
      Day of the week
    </KText>
    <KSelect
      options={dayOfWeekOptions}
      value={dayOfWeekOptions.find(
        (option) => option.value === selectedDayOfWeek
      )}
      onChange={(dayOfWeek) => setSelectedDayOfWeek(dayOfWeek.value)}
      menuPlacement="top"
      customStyles={{
        menuList: (base) => ({
          ...base,
          maxHeight: '200px',
          overflowY: 'auto',
        }),
      }}
    />
  </Flex>
);
